import { Protocol } from './index';
import { Category } from '../constants';

const paymaster: Protocol[] = [
  {
    name: 'Zyfi',
    url: 'https://zyfi.org',
    logoPath: '/logos/zyfi.png',
    category: Category.Paymaster,
    twitterUrl: 'https://x.com/Zyfi_org',
  },
];

export { paymaster };
